import { OrderedList } from './OrderedList'

export default OrderedList
